function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-logo_4);\n      }\n\n      .cls-2 {\n        fill: #505762;\n      }\n\n      .cls-3 {\n        fill: #74d5de;\n      }\n\n      .cls-13, .cls-4, .cls-6, .cls-7 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-4 {\n        stroke: #56cad8;\n      }\n\n      .cls-13, .cls-4, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: 4px;\n      }\n\n      .cls-5 {\n        fill: #56cad8;\n      }\n\n      .cls-6 {\n        stroke: #74d5de;\n        stroke-linejoin: round;\n      }\n\n      .cls-7 {\n        stroke: #6d6d6d;\n        stroke-width: 3px;\n      }\n\n      .cls-8 {\n        fill: #fd8369;\n      }\n\n      .cls-9 {\n        fill: #333;\n      }\n\n      .cls-10 {\n        fill: #de8e68;\n      }\n\n      .cls-11 {\n        fill: #fcc486;\n      }\n\n      .cls-12 {\n        fill: #fed385;\n      }\n\n      .cls-13 {\n        stroke: #333;\n        stroke-width: 7px;\n      }\n\n      .cls-14 {\n        fill: #fed892;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-logo_4"
}, /*#__PURE__*/React.createElement("rect", {
  width: 201,
  height: 161
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "logo_4",
  "data-name": "logo \\u2013 4",
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(5.224 -0.07)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  className: "cls-2",
  d: "M160,180.53c17.261-11.95,50.176-29.481,81.668-41.593q.837-.749,1.7-1.51c12.9-11.407,30.13-25.638,32.205-41.2,2.043-15.593-11.064-32.548-27.1-41.705-16.036-9.125-35-10.489-54-10.528s-38.03,1.228-47.5,11.545c-9.426,10.287-9.29,29.654-10.72,47.324s-4.459,33.672.136,48.652C140.154,163.845,149.1,175.527,160,180.53Z",
  transform: "translate(-107.123 -35.165)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  className: "cls-3",
  d: "M702.394,121.135c-1.672-.573-7.144-7.812-7.144-16.4,0-9.981,10.557-28.873,11.561-35.6.639-4.28,3.521-41.99,25.409-41.99,11.936,0,12.931,23.336,12.931,33.774,0,24.382-35.452,45.151-35.452,57.815a54.179,54.179,0,0,1-7.3,2.406Z",
  transform: "translate(-555.995 -21.685)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  className: "cls-4",
  d: "M744.36,221.544c0-19.553,14.592-55.177,27.426-67.714",
  transform: "translate(-595.268 -123)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  className: "cls-5",
  d: "M307.086,505.061c-1.118-.333-4.156-4.206-4.156-9.2,0-4.807,1.35-11.817,1.35-18.321,0-3.617-1.35-4.9-1.35-9.2,0-6.86,6.5-8.949,8.781-8.949a5.1,5.1,0,0,1,5.15,4.39c0,2.121-.6,3.732-.6,6.079,0,4.589,1.6,5.164,1.434,9.117-.5,11.559-5.3,22.86-9.518,25.423Z",
  transform: "translate(-242.255 -367.358)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  className: "cls-3",
  d: "M64.832,374.038c1.37-1.182-6.3-38.557-12.955-45.171-7.239-7.189-13.189-10.994-15.154-13.354-3.485-4.184-5.7-19.963-21.045-19.963-4.058,0-13.62,3.355-15.341,17.554C-.226,317.765-1.25,324.9,8.45,335.228c6.534,6.962,14.706,4.565,22.693,12.108,5.75,5.43,4.945,13.62,10.315,20.54C45.755,373.4,56.91,380.862,64.832,374.038Z",
  transform: "translate(0 -236.334)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  className: "cls-4",
  d: "M148.869,461.209c0-9.38-29.59-51.714-41.429-57.769",
  transform: "translate(-85.92 -322.614)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  className: "cls-6",
  d: "M321.872,575.643c-.294-2.223-1.536-21.111,1.983-27.993",
  transform: "translate(-257.04 -437.94)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  className: "cls-7",
  d: "M207,519.454c8.855-12.645,87.958-55.784,135.478-63.754",
  transform: "translate(-165.539 -364.407)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  className: "cls-8",
  width: 24.021,
  height: 44.662,
  rx: 12,
  transform: "translate(88.268 22.638)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  className: "cls-9",
  d: "M394.541,696.419v5.208H380.4v-2.2l8.761-4.024Z",
  transform: "translate(-304.208 -556.096)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  className: "cls-9",
  d: "M557.055,675.56c.715,1.6,2.4,5.755,2.4,5.755l-7.056,4.437h-6.393l-.749-2.452,8.032-6.147Z",
  transform: "translate(-436.047 -540.23)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  className: "cls-10",
  cx: 5.963,
  cy: 7.519,
  rx: 5.963,
  ry: 7.519,
  transform: "translate(90.604 6.602)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  className: "cls-10",
  d: "M367,.692c-.781-1.074-2.986-.831-4.925.565a6.778,6.778,0,0,0-1.835,1.937.537.537,0,0,0-.2-.046c-.941,0-16.59,8.37-16.442,12.232s5.4,10.055,7.231,11.243c0,0,8.27-3.862,7.826-5.1s-5.208-5.208-6.043-5.993c.981-.513,8.837-8.3,9.724-9.178a6.654,6.654,0,0,0,2.574-1.164C366.842,3.788,367.781,1.777,367,.692Z",
  transform: "translate(-274.774)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  "data-name": "Path 93",
  className: "cls-11",
  d: "M386.337,111.076c1.8-1.45-1.182-13.61-4.38-13.909s-8.777,5.728-8.553,7.439S381.782,114.721,386.337,111.076Z",
  transform: "translate(-298.608 -77.678)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  "data-name": "Path 94",
  className: "cls-5",
  d: "M402.27,298.81c0,2,1,71.305,2.8,77.314,1.6.8,5.809,1,7.211.4s10.349-76.617,10.349-79.954S402.27,298.81,402.27,298.81Z",
  transform: "translate(-321.697 -236.299)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  className: "cls-3",
  d: "M466.732,374.663c-1.913-3-26.82-61.346-28.772-75.732,2.045-1.584,17.263-4.11,18.5-1.234s16.024,73.987,15.517,74.91S468.17,374.971,466.732,374.663Z",
  transform: "translate(-350.239 -237.003)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_96",
  "data-name": "Path 96",
  className: "cls-12",
  d: "M411.142,119c12.919,0,12.118,35.753,9.314,37.956s-24.736,2.3-26.139.7S389.6,119,411.142,119Z",
  transform: "translate(-314.492 -95.146)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  className: "cls-8",
  d: "M453.906,18.562c0-1.524-1.456-2.624-1.456-3.469s.5-2.359-.617-3.443c-1.356-1.316-3.517-.767-5.452-.767-1.819,0-2.822-2.113-5.3-2.113-1.654,0-1.444,2.147-2.063,2.68-.459.4-4.034,1.17-4.034,2.8,0,1.827.048,4.278,3.842,4.278a8.778,8.778,0,0,1,2.283-3.661c.557.24,3.605,1.5,4.36,1.721s1.859,3.455,3.028,3.846,1.244,2.544,2.1,2.452S453.906,22.436,453.906,18.562Z",
  transform: "translate(-347.855 -6.995)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7",
  "data-name": "Ellipse 7",
  className: "cls-10",
  cx: 1.576,
  cy: 1.576,
  r: 1.576,
  transform: "translate(100.124 13.138)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_98",
  "data-name": "Path 98",
  className: "cls-10",
  d: "M475.242,93.375c-.252.871-5.55-.186-5.448-1.172l.905-8.753,6.383,1.374S475.5,92.507,475.242,93.375Z",
  transform: "translate(-375.695 -66.717)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_20",
  "data-name": "Line 20",
  className: "cls-13",
  x1: 22.403,
  y2: 111.058,
  transform: "translate(113.229 31.353)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  className: "cls-10",
  d: "M561.928,215.275a4.084,4.084,0,0,0-2.2-1.152c-2.672-4.312-11.751-17.6-15.755-22.433a60.267,60.267,0,0,0-6.409,5.7c1.472,1.65,12.5,14.7,18.365,19.811a3.988,3.988,0,0,0,1.2,2.878,3.418,3.418,0,1,0,4.8-4.8Z",
  transform: "translate(-429.889 -153.277)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  className: "cls-14",
  d: "M501.79,144.571c5.182-3.852,13.724,5.462,13.584,7.912s-6.706,7.882-8.951,7.888C503.681,160.374,497.38,147.85,501.79,144.571Z",
  transform: "translate(-400.066 -114.859)"
})));

var SvgHikerManColour = function SvgHikerManColour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: 300,
    viewBox: "0 0 201 161",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHikerManColour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hiker-man-colour.6aa025c4.svg";
export { ForwardRef as ReactComponent };